import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

const UploadPicture = () => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "16px" }}>
    <Avatar
      sx={{
        width: "80px",
        height: "80px",
        backgroundColor: "#F5F5F5",
        border: "2px dashed #BDBDBD",
      }}
    >
      <AddPhotoAlternateIcon sx={{ fontSize: "40px", color: "#BDBDBD" }} />
    </Avatar>
    <Typography variant="caption" sx={{ marginTop: "8px" }}>
      Upload Picture
    </Typography>
  </Box>
);

export default UploadPicture;